import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Blacklist from "@/pages/Blacklist";
import BlacklistDetail from "@/pages/BlacklistDetail";
import Search from "@/pages/Search";
import ReportForm from "@/pages/ReportForm";
import MyReports from "@/pages/MyReports";
import Employees from "@/pages/Employees";
import AdminCompanies from "@/pages/AdminCompanies";
import AdminReports from "@/pages/AdminReports";
import AdminBlacklistForm from "@/pages/AdminBlacklistForm";
import SecurityLog from "@/pages/SecurityLog";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-primary font-display">
        Đang tải...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" theme="dark" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/danh-sach-den" element={<Protected><Blacklist /></Protected>} />
            <Route path="/danh-sach-den/:id" element={<Protected><BlacklistDetail /></Protected>} />
            <Route path="/tra-cuu" element={<Protected><Search /></Protected>} />
            <Route path="/bao-cao" element={<Protected roles={["company"]}><ReportForm /></Protected>} />
            <Route path="/bao-cao-cua-toi" element={<Protected roles={["company"]}><MyReports /></Protected>} />
            <Route path="/nhan-vien" element={<Protected roles={["company"]}><Employees /></Protected>} />
            <Route path="/duyet-nha-xe" element={<Protected roles={["root"]}><AdminCompanies /></Protected>} />
            <Route path="/them-danh-sach" element={<Protected roles={["root"]}><AdminBlacklistForm /></Protected>} />
            <Route path="/sua-danh-sach/:id" element={<Protected roles={["root"]}><AdminBlacklistForm /></Protected>} />
            <Route path="/duyet-bao-cao" element={<Protected roles={["root"]}><AdminReports /></Protected>} />
            <Route path="/nhat-ky-bao-mat" element={<Protected roles={["root"]}><SecurityLog /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
